import { render, staticRenderFns } from "./CoverageDetailFileTransfertGlider.vue?vue&type=template&id=b6f59a2c"
import script from "./CoverageDetailFileTransfertGlider.vue?vue&type=script&setup=true&lang=ts"
export * from "./CoverageDetailFileTransfertGlider.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports